// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Oba-z","narrowOptionButtons":"Pba-z","noOptions":"Qba-z"};